export default "<button class=\"tab-button\" [ngClass]=\"{'active': isActive}\" (click)=\"onClick()\">\n  {{ label }}\n</button>"